import { AddedToBagContainer } from "@faire/add-to-cart/components/AddedToBagNotification/AddedToBagStore";
import { useAddedToBag } from "@faire/add-to-cart/components/AddedToBagNotification/useAddedToBag";
import {
  SHOW_SIDE_CART_QUERY_PARAM,
  SHOW_SIDE_CART_QUERY_PARAM_VALUE,
} from "@faire/add-to-cart/lib/consts";
import { useSettingCartBuildingAndSavingsGuide } from "@faire/add-to-cart/settings/useSettingCartBuildingAndSavingsGuide";
import { route as productRoute } from "@faire/web-api--source/routes/www/product/productToken";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import { useCallback, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

export const useShowBrandCartOrNotification = (showSideCart: boolean) => {
  const [hasSideCartBeenShown, setHasSideCartBeenShown] =
    useState(showSideCart);

  const history = useHistory();
  const { search, pathname } = useLocation();

  const isOnPDP = pathMatchesRoute(pathname, productRoute);

  const { isDesktopAndAbove } = useViewport();
  const { ignoreContainer } = useAddedToBag();
  const cartBuildingAndSavingsGuideEnabled =
    useSettingCartBuildingAndSavingsGuide();

  return useCallback(
    (setAddToCartNotificationInProgress: (value: boolean) => void) => {
      if (
        !hasSideCartBeenShown &&
        isDesktopAndAbove &&
        isOnPDP &&
        cartBuildingAndSavingsGuideEnabled
      ) {
        const searchParams = new URLSearchParams(search);

        ignoreContainer(AddedToBagContainer.BRAND_CART, true);

        searchParams.set(
          SHOW_SIDE_CART_QUERY_PARAM,
          SHOW_SIDE_CART_QUERY_PARAM_VALUE
        );

        // Doing a replace so that showing side cart does not create a chain of history entries
        history.replace({
          pathname,
          search: searchParams.toString(),
        });

        setHasSideCartBeenShown(true);
      } else {
        setAddToCartNotificationInProgress(showSideCart ? false : true);
      }
    },
    [
      hasSideCartBeenShown,
      cartBuildingAndSavingsGuideEnabled,
      isDesktopAndAbove,
      isOnPDP,
      search,
      ignoreContainer,
      history,
      pathname,
      showSideCart,
    ]
  );
};
